let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kYEsp")).then(() => parcelRequire('fr2U1'));